import type { Content } from '@gra/content';
import { emptyStats, type Loadout, type Profile } from '@gra/engine';

const KEY = 'echa-pustkowi.profile.v1';

/** Starsze wersje zapisu → aktualna. Każda migracja to jeden krok wersji. */
function migrate(raw: Record<string, unknown>, content: Content): Profile | null {
  if (raw.version === 1) {
    // v1: jeden zestaw sprzętu dla wszystkich klas → v2: osobny zestaw na klasę.
    raw.equipped = { [raw.classId as string]: raw.equipped as Loadout };
    raw.version = 2;
  }
  if (raw.version === 2 && typeof raw.gold !== 'number') raw.gold = 0; // złoto doszło później w v2
  if (raw.version === 2 && (typeof raw.upgrades !== 'object' || raw.upgrades === null)) raw.upgrades = {}; // drzewko rozwoju też
  if (raw.version === 2 && typeof raw.raceId !== 'string') raw.raceId = Object.keys(content.races)[0]; // rasy doszły później
  if (raw.version === 2 && raw.gender !== 'm' && raw.gender !== 'k') raw.gender = 'm';
  // Osiągnięcia, odłamki i szersze statystyki doszły później: brakujące pola dostają wartości startowe.
  if (raw.version === 2) {
    raw.stats = { ...emptyStats(), ...(raw.stats as object) };
    if (typeof raw.shards !== 'number') raw.shards = 0;
    if (typeof raw.achievements !== 'object' || raw.achievements === null) raw.achievements = {};
    if (typeof raw.title !== 'string') raw.title = null;
    if (typeof raw.frame !== 'string') raw.frame = null;
  }
  return raw.version === 2 ? (raw as unknown as Profile) : null;
}

/** Zapis profilu w przeglądarce. Docelowo serwer — interfejs zostaje ten sam. */
export function loadProfile(content: Content): Profile | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const p = migrate(JSON.parse(raw) as Record<string, unknown>, content);
    if (!p || !content.classes[p.classId]) return null;
    if (!content.races[p.raceId]) p.raceId = Object.keys(content.races)[0]!;
    // Przedmioty usunięte z danych gry znikają z ekwipunku zamiast psuć zapis.
    p.inventory = p.inventory.filter((i) => content.items[i.itemId] && content.rarities[i.rarity]);
    for (const [classId, loadout] of Object.entries(p.equipped)) {
      for (const [slot, uid] of Object.entries(loadout)) {
        const inst = p.inventory.find((i) => i.uid === uid);
        // Zdejmujemy też to, czego klasa już nie może nosić (np. po zmianie danych).
        if (!inst || !content.items[inst.itemId]!.classes.includes(classId)) delete loadout[slot as keyof Loadout];
      }
    }
    return p;
  } catch {
    return null;
  }
}

export function saveProfile(profile: Profile): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(profile));
  } catch {
    // brak dostępu do localStorage (tryb prywatny) — gra działa dalej bez zapisu
  }
}
